import { fetchApi } from "../fetchApi";

export async function connectSocialMedia() {
  const returnURL = window.location.href;
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [returnURL],
      model: "res.users",
      method: "action_social_media",
      kwargs: {},
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };
  return fetchApi({
    requestOptions,
    endpoint: `/web/dataset/call_kw/res.users/action_social_media`,
  });
}
